import DefaultChangePassword from "src/components/feature/ChangePassword";

const ChangePassword = () => {
  return <DefaultChangePassword />;
};

export default ChangePassword;
